import React, { useEffect, useState } from "react"
import { enumUtil } from "../../../../../utils/Enum"
import FormValidator from "../../../../../utils/FormValidator"
import { ServerRequestProtected } from "../../../../../utils/ServerDataRequest"
import NotificationHandler from "../../../../../utils/NotificationHandler"
import isNull from "../../../../../utils/NullChecking"
import Modal from 'react-bootstrap/Modal';
import ModalHeader from "../../../../Setup/Shared/ModalHeader"
import { PWK } from '../../../../../utils/Constants';
import ModalFooter from "../../../../Setup/Shared/ModalFooter"
import { FindFirstChild, FindSecondChild } from "../../../../../utils/FindMenuOption"
import Loader from "../../../../shared/Loader/Loader"
import SuperSearchList from "../../../../shared/SuperSearch/SuperSearchList"
import DropdownValueHandler from "../../../../shared/SuperSearch/DropdownValueHandler"
const AddNewDocumentType = (props) => {
  let IsEditAllowed = FindSecondChild('Billing', 'Claims', 'Document')?.IsAdd
  let IsDeleteAllowed = FindSecondChild('Billing', 'Claims', 'Document')?.IsDeleted
  const DocumentType = {
    DocumentType: '',
    PWKDocumentType: '',
    DocumentDescription: '',
  }
  let valModal = {}
  let ValidationModal = {
    DocumentTypeVal: '',
  }
  const [documentTypeID, setDocumentTypeID] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const API_URL = enumUtil.controller.General
  const { isOpenDocumentType, onClose, setisDocumetTypeSaved } = { ...props }
  const [del, setDel] = useState(false)
  const [DocumetTypeValidationModal, setDocumetTypeValidationModal] = useState(ValidationModal)
  const [mainDocumentTypeModal, setMainDocumentTypeModal] = useState(DocumentType)
  const [DocumentSaveUpdateModal, setDocumentSaveUpdateModal] = useState({})

  useEffect(() => {
    if (props.DocumentTypeID != null) {
      setDocumentTypeID(props.DocumentTypeID)
    }
    if (!isNull(documentTypeID)) {
      setIsLoading(true)
      ServerRequestProtected(API_URL + "/FindByID", 'post', {
        "ID": documentTypeID,
        "TableName": enumUtil.enumAPITableName.DocumentType

      }).then((response) => {
        setIsLoading(false);
        response.PWKDocumentType = DropdownValueHandler(PWK, response.PWKDocumentType)
        setMainDocumentTypeModal(response)
      }).catch((error) => {
        NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
        setIsLoading(false)
      })
    }
  }, [documentTypeID])
  const [is, setIs] = useState(true);

  //handle Change Document Type
  const handleDocumentTypeChange = (e) => {
    setIs(false)

    let { name, value } = e.target;
    if (process.env.REACT_APP_ISUPPERCASE === "true") {
      value = value.toUpperCase()
    }
    let modal = { ...mainDocumentTypeModal };
    let saveModal = { ...DocumentSaveUpdateModal }
    modal[name] = value
    setMainDocumentTypeModal(modal)
    for (var property in DocumentType) {
      if (name === property) {
        saveModal[name] = value
      }
    }
    setDocumentSaveUpdateModal(saveModal)
  }
  const handleSelectedData = (selectedData, name, type) => {
    setIs(true)
    let modal = { ...mainDocumentTypeModal };
    if (type === 'client' && !isNull(selectedData)) {
      modal[name] = selectedData.display
      DocumentSaveUpdateModal[name] = selectedData.value;
    }
    else {
      modal[name] = ''
      DocumentSaveUpdateModal[name] = ''
    }
    setMainDocumentTypeModal(modal)
    return selectedData
  }
  // Document Type Validation function
  const DocuumentTypeValidation = async () => {
    let ValidationModal = {
      DocumentTypeVal: FormValidator(
        mainDocumentTypeModal.DocumentType,
        enumUtil.enumValidationType.Required,
        'Document Type',
      ),
    }
    await setDocumetTypeValidationModal(ValidationModal)
    valModal = ValidationModal
  }
  //handle Save Document Type
  const handleSaveDocumentType = async () => {

    await DocuumentTypeValidation()

    let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
    if (validation) {
      NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
      return
    } else {
      //   if (DocumentTypeParentID != '0') {
      //     DocumentSaveUpdateModal['documentTypeID'] = DocumentTypeParentID
      //   }
      let saveModal = {
        TableName: enumUtil.enumAPITableName.DocumentType,
        ID: documentTypeID,
        data: { ...DocumentSaveUpdateModal },
      }
      setIsLoading(true)
      ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
        .then((response) => {
          if (!isNull(response.id)) {
            setIsLoading(false)
            NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
            setDocumentTypeID(response.id)
            // setMainDocumentTypeModal(DocumentType)
            // setDocumentTypeParentID('0')
            setisDocumetTypeSaved(prev => !prev)
          }
        }).catch((error) => {
          setIsLoading(false)
          NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
          console.log('error', error);
        })
    }
  }

  // handle Open and Close Delete Document Modal
  let DeleteConfirmation = "";
  const handleDeleteModal = () => {
    setDel(true)
  }
  let DeletePopup = ""
  if (del) {
    DeletePopup = <button className={IsDeleteAllowed === false ? 'btn-icon-transparent delete-btn-disabled' : 'btn-icon-transparent '} onClick={handleDeleteModal}><span className="icon"><i className="icon-delete"></i></span><span className="title">Delete</span></button>
  }
  const SetDocumentTypeName = () => {
    if (mainDocumentTypeModal.DocumentType != null && mainDocumentTypeModal.DocumentType != "") {
      return (
        <p className="heading validation_message">{mainDocumentTypeModal.DocumentType}</p>
      )
    } else {
      return (
        <p className="heading">Add New Document Type</p>
      )
    }
  }
  return (
    <React.Fragment>
      {console.log("mainDocumentTypeModal", mainDocumentTypeModal)}
      {isLoading ? <Loader /> : null}
      {DeletePopup}
      {DeleteConfirmation}
      <Modal show={isOpenDocumentType} onHide={() => onClose()} backdrop="static" keyboard={false} centered dialogClassName="app-modal add_doc_types hk-modal-v1">
        <Modal.Body>
          <ModalHeader HeaderName={SetDocumentTypeName} DeletePopup={""} isClosed={onClose} key={612} Name={'Documents'} />
          <div className={DocumetTypeValidationModal.DocumentTypeVal ? 'form-group input error' : 'form-group input'}>
            <label htmlFor="DocumentType mb-2">Document Type<span className='req'>*</span></label>
            <input
              type="text"
              className="form-control"
              id="DocumentType"
              name="DocumentType"
              value={mainDocumentTypeModal.DocumentType}
              onChange={handleDocumentTypeChange}
            />
            {DocumetTypeValidationModal.DocumentTypeVal}
          </div>
          <div className="form-group input">
            <label htmlFor="DocumentDescription">Document Description</label>
            <textarea
              type="text"
              className="form-control"
              id="DocumentDescription"
              name="DocumentDescription"
              value={mainDocumentTypeModal.DocumentDescription}
              onChange={handleDocumentTypeChange}
              rows="3"
            />
          </div>
          <div className="form-group input">
            <label htmlFor="PWKDocumentType" className="mb-2">PWK Document Type</label>
            <SuperSearchList
              type="client"
              id='PWKDocumentType'
              name='PWKDocumentType'
              searchValue={mainDocumentTypeModal.PWKDocumentType}
              data={PWK}
              onChange={handleDocumentTypeChange}
              getSelectedData={handleSelectedData}
              is={is}
              sup_btn='sup_btn-Inp'
              sup_inp='superSearchVisitInp'
            // inputError={DocumetValidationModal.DocumentTypeVal}
            />
            {/* <select
              id='PWKDocumentType'
              name='PWKDocumentType'
              className='form-control fc-xs'
              value={mainDocumentTypeModal.PWKDocumentType}
              onChange={handleDocumentTypeChange}
              placeholder="Type to write" >
              {PWK?.map((e, index) => (
                <option className='listing_ad' value={e.value} key={index}>
                  {e.display}
                </option>
              ))}
            </select> */}
          </div>
        </Modal.Body>
        <ModalFooter isSaved={onClose} handleSave={handleSaveDocumentType} UpdatedDate={mainDocumentTypeModal.UpdatedDate} UpdatedBy={mainDocumentTypeModal.UpdatedBy} ID={documentTypeID} IsEditAllowed={IsEditAllowed} />
      </Modal>
    </React.Fragment>
  )
}

export default AddNewDocumentType